import React from 'react'

export default function SelectButton({isActive, icon, activeIcon, text, handleButtonClick}) {
    return (
        <div onClick={handleButtonClick} className={`lover-select-button  ${isActive ? 'lover-select-button-active' : null}`}>
            <img src={isActive ? require(`../../../assets/icons/${activeIcon}`) : require(`../../../assets/icons/${icon}`)} />
            <p>{text}</p>
        </div>
    )
}
